import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeGerman: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00001 4.2411C6.77957 4.2411 5.79022 5.21012 5.79022 6.40548C5.79022 7.60084 6.77957 8.56986 8.00001 8.56986C9.22044 8.56986 10.2098 7.60084 10.2098 6.40548C10.2098 5.21012 9.22044 4.2411 8.00001 4.2411ZM6.62938 6.40548C6.62938 5.66406 7.24303 5.06301 8.00001 5.06301C8.75698 5.06301 9.37064 5.66406 9.37064 6.40548C9.37064 7.1469 8.75698 7.74795 8.00001 7.74795C7.24303 7.74795 6.62938 7.1469 6.62938 6.40548Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.04932C5.79086 2.04932 4 3.80338 4 5.96712C4 7.03083 4.53861 8.63455 5.24142 10.1259C5.94808 11.6255 6.86801 13.1108 7.70331 13.9289C7.85951 14.0819 8.11006 14.0901 8.2763 13.9476C9.2408 13.121 10.1659 11.6215 10.8451 10.1202C11.5236 8.62053 12 7.02268 12 5.96712C12 3.80338 10.2091 2.04932 8 2.04932ZM4.83916 5.96712C4.83916 4.25731 6.25432 2.87123 8 2.87123C9.74568 2.87123 11.1608 4.25731 11.1608 5.96712C11.1608 6.84835 10.7421 8.31899 10.0779 9.7872C9.49301 11.0801 8.75139 12.2962 8.01819 13.051C7.35195 12.2868 6.60927 11.0673 6.00334 9.78147C5.30754 8.30498 4.83916 6.84019 4.83916 5.96712Z"
        fill="black"
      />
    </svg>
  );
};

export default BadgeGerman;
